import * as types from '../constants/activityConstants';

export function adduserLogInActivity(){
    const user = JSON.parse(localStorage.getItem('user'));
  var msg={
    BCM:'7',
    MSG:user.trdCode+' logged in.'
  }
  return {
    type: types.ADD_ACTIVITYCOMPONENT,
    msg
  };
}
export function loadActivityComponent() {
  return {
    type: types.LOAD_ACTIVITYCOMPONENT
  };
}
export function closeOrdConfirmMsg(){
  return {
    type: types.UPDATE_ORDCNFMSG
  }
}

export function closePhysicalDeliveryOrdCnfrmMsg() {
  return {
    type: types.UPDATE_PHYSICAL_DELIVERY_ORD_CNFRM_MSG
  };
}

export function closeInvalidCheckModal(){
  return {
    type: types.CLOSE_INVALIDCHECKMODAL
  }
}
export function resetState(){
  return{
    type:types.RESET_STATE
  }
}
// export function refreshProximity(){
//   console.log(" action refreshProxi");
//   //console.log("refreshProximity socketData "+JSON.stringify(socketData));
//   return{
//     type:types.REFRESH_PROXIMITY
//
//     }
// }
export function closeBMAlert(benmFillObj){
    return{
      type:types.CLOSE_BM_MODAL,benmFillObj
    }
}
export function closeReqRejectModal(requestRejectModal){
    return{
      type:types.CLOSE_REQ_REJECTED_MODAL,requestRejectModal
    }
}
export function setOrdersCTID(ctid){
    return{
      type:types.GET_ORDERS_CTID,
      ctid
    }
}
//refresh tradeBookData
export function setRefreshFlag(flag,key) {
  return {
    type: types.ENABLE_LOADER_FLAG,
    flag,
    key
  };
}
//refresh orderBookData
export function orderRefreshFlag(flag) {
  return {
    type: types.ORDER_REFRESH_FLAG,
    flag
  };
}
export function openTrdRefreshFlag(flag) {
  return {
    type: types.OPENTRD_REFRESH_FLAG,
    flag
  };
}

//trde CTID
export function setTrdCTID(ctid){
    return{
      type:types.GET_TRADE_CTID,
      ctid
    }
}
//dealFailed flag
export function closeDealFailedModal(flag){
   return{
     type:types.DEAL_FAILED_FLAG,
     flag
   }
}
//refresh fixing Order
export function fixOrdRefreshFlag(flag) {
  return {
    type: types.FIX_ORD_REFRESH_FLAG,
    flag
  };
}
